// WebSocketContext.js

// import React, { createContext, useState, useEffect } from "react";
// import WebSocketService from "./websocketService";

// const WebSocketContext = createContext();

// const WebSocketProvider = ({ children, resource, stockIDs }) => {
//   const [stocks, setStocks] = useState([]);
//   const [lastUpdateTime, setLastUpdateTime] = useState(null);

//   useEffect(() => {
//     const updateStockData = (data) => {
//       // Your logic to update stocks based on data
//       console.log("Stock data received: ", data);
//       // Update stocks state here
//     };

//     const wsService = new WebSocketService(
//       resource,
//       stockIDs,
//       updateStockData,
//       setLastUpdateTime
//     );
//     wsService.connect();

//     return () => {
//       wsService.disconnect();
//     };
//   }, [resource, stockIDs]);

//   return (
//     <WebSocketContext.Provider value={{ stocks, lastUpdateTime }}>
//       {children}
//     </WebSocketContext.Provider>
//   );
// };

// export { WebSocketProvider, WebSocketContext };


// import React, { createContext, useState, useEffect } from "react";
// import WebSocketService from "./websocketService";

// const WebSocketContext = createContext();

// const WebSocketProvider = ({ children, resource, stockIDs }) => {
//   const [stocks, setStocks] = useState([]);
//   const [lastUpdateTime, setLastUpdateTime] = useState(null);

//   useEffect(() => {
//     const updateStockData = (data) => {
//       console.log("Stock data received: ", data);
//       setStocks((prevStocks) => {
//         // Logic to update stocks based on received data
//         return [...prevStocks, data]; // Adjust this logic as needed
//       });
//       setLastUpdateTime(new Date());
//     };

//     const wsService = new WebSocketService(
//       resource,
//       stockIDs,
//       updateStockData,
//       setLastUpdateTime
//     );
//     wsService.connect();

//     return () => {
//       wsService.disconnect();
//     };
//   }, [resource, stockIDs]);

//   return (
//     <WebSocketContext.Provider value={{ stocks, lastUpdateTime }}>
//       {children}
//     </WebSocketContext.Provider>
//   );
// };

// export { WebSocketProvider, WebSocketContext };






// import React, { createContext, useState, useEffect } from "react";
// import WebSocketService from "./websocketService";

// const WebSocketContext = createContext();

// const WebSocketProvider = ({ children, resource, stockIDs }) => {
//   const [stocks, setStocks] = useState({});
//   const [lastUpdateTime, setLastUpdateTime] = useState(null);

//   useEffect(() => {
//     const updateStockData = (data) => {
//       console.log("Stock data received: ", data);
//       setStocks((prevStocks) => ({
//         ...prevStocks,
//         [data.Symbol]: data, // Assuming data has a 'Symbol' key
//       }));
//       setLastUpdateTime(new Date());
//     };

//     const wsService = new WebSocketService(
//       resource,
//       stockIDs,
//       updateStockData,
//       setLastUpdateTime
//     );
//     wsService.connect();

//     return () => {
//       wsService.disconnect();
//     };
//   }, [resource, stockIDs]);

//   return (
//     <WebSocketContext.Provider value={{ stocks, lastUpdateTime }}>
//       {children}
//     </WebSocketContext.Provider>
//   );
// };

// export { WebSocketProvider, WebSocketContext };



import React, { createContext, useState, useEffect, useRef } from 'react';
import WebSocketService from './websocketService'; // Assuming WebSocketService handles WebSocket connections
import WebSocketServiceGlobal from './websocketServiceGlobal'; // WebSocket service for COMEX, FOREX, GLOBAL (port 8084)
import { apiAppFetch } from './utils/apiFetch';
import { setDepositWithdrawFlags } from './utils/depositWithdrawAccess';
import { useNavigate } from 'react-router-dom';

// ============================================
// NOTIFICATION INTEGRATION - Easy to disable
// ============================================
// To disable notifications: Comment out the import below
// DISABLED FOR DEPLOYMENT - Uncomment when ready to test
// import useNotifications from './hooks/useNotifications';

const WebSocketContext = createContext();

const WebSocketProvider = ({ user_id, children, resource, stockIDs }) => {
  const [stocks, setStocks] = useState({});
  const [lastUpdateTime, setLastUpdateTime] = useState(null);
  const [trades, setTrades] = useState([]);
  const [positions, setPortfolio] = useState([]);
  const [performance, setPerformance] = useState([]);
  const [userDetails, setUserDetails] = useState({});
  const [userScripts, setUserScripts] = useState({});
  const [stockids, setStockids] = useState([]);
  const [globalStockids, setGlobalStockids] = useState([]); // For COMEX, FOREX, GLOBAL exchanges
  const wsServiceRef = useRef(null);
  const wsServiceGlobalRef = useRef(null); // WebSocket service for global exchanges
  const [isRefreshing, setRefreshing] = useState(false);
  const navigate = useNavigate();

  const handleUnauthorized = (response) => {
    if (response.status === 401) {
      localStorage.removeItem('authToken');
      navigate('/login');
      return true;
    }
    return false;
  };

  // ============================================
  // NOTIFICATION INTEGRATION - Easy to disable
  // ============================================
  // DISABLED FOR DEPLOYMENT - Uncomment when ready to test
  // To disable: Comment out the line below
  // const { notifications, isConnected: isNotificationConnected } = useNotifications(user_id, ['all']);
  // Alternative: Subscribe to specific types only
  // const { notifications, isConnected: isNotificationConnected } = useNotifications(user_id, ['auto_exit', 'pending_order_execution', 'order_executed']);
  
  // Placeholder values when notifications are disabled
  const notifications = [];
  const isNotificationConnected = false;

  const submitRejectionLog = async (data) => {
    try {
      
      const response = await apiAppFetch('createRejectionLog', {
        method: 'POST',
        body: data,
      });
      const dataa = await response.json();
      
      // // Sort the data by orderId in descending order
      // const sortedData = data.sort((a, b) => b.orderId - a.orderId);
      
      // setTrades(sortedData); // Assuming data is an array of trades
      // setRefreshing(false);
    } catch (error) {
      // console.error('Error fetching trades:', error);
      // setRefreshing(false);
    }
  };
 
  // Function to fetch trades from API
  const fetchTrades = async (user_id) => {
    try {
      const response = await apiAppFetch('getOrders', {
        method: 'POST',
        body: JSON.stringify({}),
      });
      if (handleUnauthorized(response)) return;
      const data = await response.json();
      
      // Sort the data by orderId in descending order
      const sortedData = data.sort((a, b) => b.orderId - a.orderId);
      
      setTrades(sortedData); // Assuming data is an array of trades
      setRefreshing(false);
    } catch (error) {
      console.error('Error fetching trades:', error);
      setRefreshing(false);
    }
  };

  // performanceFromMonday

  // Function to fetch performance from API
  const fetchPerformance = async (user_id) => {
    
    try {
      const response = await apiAppFetch('performanceFromMonday', {
        method: 'POST',
        body: JSON.stringify({}),
      });
      if (handleUnauthorized(response)) return;
      const data = await response.json();

      // Sort the data by orderId in descending order
      const sortedData = data.sort((a, b) => b.closing_order.orderId - a.closing_order.orderId);

      // /console.log("Data Received : "+data[0]['orderId']);
      setPerformance(sortedData); // Assuming data is an array of portfolio positions
      setRefreshing(false);
    } catch (error) {
      console.error('Error fetching portfolio:', error);
      setRefreshing(false);
    }
  };


  const mergerIDsEx = async (instrumentTokens) => {
    wsServiceRef.current.mergerIDs(instrumentTokens);
  }

  // Function to fetch portfolio from API
  const fetchPortfolio = async (user_id) => {
    
    try {
      const response = await apiAppFetch('portfolio', {
        method: 'POST',
        body: JSON.stringify({}),
      });
      if (handleUnauthorized(response)) return;
      const data = await response.json();
      // /console.log("Data Received : "+data[0]['orderId']);

      const instrumentTokens = data.map(script => script.instrument_token);
      console.log(instrumentTokens);
      //setStockids(instrumentTokens);
      wsServiceRef.current.mergerIDs(instrumentTokens);
      //reconnectWebSocket();

      
      const sortedData = data.sort((a, b) => b.orderId - a.orderId);

      setPortfolio(sortedData); // Assuming data is an array of portfolio positions
      setRefreshing(false);
    } catch (error) {
      console.error('Error fetching portfolio:', error);
      setRefreshing(false);
    }
  };

  const fetchUserDetails = async () => {
    try {
      const response = await apiAppFetch('getUserDetails', {
        method: 'POST',
        body: JSON.stringify({}),
      });
      if (handleUnauthorized(response)) return;
      const data = await response.json();
      localStorage.setItem('parentId', data.parentId);

      if(data.isActive==0){
        localStorage.removeItem('authToken');
        navigate('/login');
      }

      setUserDetails(data); // Assuming data is an object of user details
      setDepositWithdrawFlags(data);
    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  };



  const fetchUserScripts = async (wsService) => {
    try 
    {  
      const clientId = user_id;
        
      const response = await apiAppFetch('getUserScriptsWithPrice', {
        method: 'POST',
        body: JSON.stringify({}),
      });
      if (handleUnauthorized(response)) return;
      
      const data = await response.json();
      
      setUserScripts(data); // Assuming data is an object of user details
      
      // Filter scripts for COMEX, FOREX, and GLOBAL exchanges
      const globalExchanges = ['COMEX', 'FOREX', 'GLOBAL'];
      const globalScripts = data.filter(script => globalExchanges.includes(script.exchange));
      const regularScripts = data.filter(script => !globalExchanges.includes(script.exchange));
      
      // Get instrument tokens for regular exchanges (port 8083)
      const instrumentTokens = regularScripts.map(script => script.instrument_token);
      setStockids(instrumentTokens);
      
      // Get instrument tokens for global exchanges (port 8084)
      const globalInstrumentTokens = globalScripts.map(script => script.instrument_token);
      setGlobalStockids(globalInstrumentTokens);
      
      // Update regular websocket service (port 8083)
      if (wsServiceRef.current) {
        wsServiceRef.current.setIDs(instrumentTokens);
        reconnectWebSocket();
      }
      
      // Update global websocket service (port 8084)
      // if (wsServiceGlobalRef.current) {
      //   wsServiceGlobalRef.current.setIDs(globalInstrumentTokens);
      //   reconnectGlobalWebSocket();
      // }

      fetchTrades(user_id);
      fetchPortfolio(user_id);
      fetchPerformance(user_id);
      fetchUserDetails();

      setRefreshing(false);
      
    } catch (error) {
      console.error('Error fetching user details:', error);
      setRefreshing(false);
    }
  };

  const fetchUserScriptsExternal = () => {
    setRefreshing(true);
    fetchUserScripts(wsServiceRef);
  };

  useEffect(() => {

    // Initialize WebSocketService for regular exchanges (port 8083)
    wsServiceRef.current = new WebSocketService(
      resource,
      stockids,
      updateStockData,
      setLastUpdateTime
    );

    // Initialize WebSocketServiceGlobal for COMEX, FOREX, GLOBAL (port 8084)
    wsServiceGlobalRef.current = new WebSocketServiceGlobal(
      resource,
      globalStockids,
      updateStockData,
      setLastUpdateTime
    );

    fetchUserScripts(wsServiceRef.current);

    // Clean up WebSocketServices on unmount
    return () => {
      if (wsServiceRef.current) {
        wsServiceRef.current.disconnect();
      }
      if (wsServiceGlobalRef.current) {
        wsServiceGlobalRef.current.disconnect();
      }
    };
  }, [resource, stockIDs]);

  const updateStockData = (data) => {
    //console.log('Stock data received::', data);
    setStocks((prevStocks) => ({
      ...prevStocks,
      [data.Symbol]: data, // Assuming data has a 'Symbol' key
    }));
    setLastUpdateTime(new Date());
  };


  const reconnectWebSocket = () => {
    if (wsServiceRef.current) {
      if (wsServiceRef.current.socket && wsServiceRef.current.socket.readyState === WebSocket.OPEN){
        console.log(`[${getTimestamp()}] Regular WebSocket reconnecting (disconnecting existing connection)...`);
        wsServiceRef.current.disconnect(); // Disconnect the existing connection
        wsServiceRef.current.connect(); // Reconnect WebSocket
      }
      else{
        console.log(`[${getTimestamp()}] Regular WebSocket connecting...`);
        wsServiceRef.current.connect(); // connect WebSocket
      }
    }
  };

  const reconnectGlobalWebSocket = () => {
    if (wsServiceGlobalRef.current) {
      if (wsServiceGlobalRef.current.socket && wsServiceGlobalRef.current.socket.readyState === WebSocket.OPEN){
        console.log(`[${getTimestamp()}] Global WebSocket reconnecting (disconnecting existing connection)...`);
        wsServiceGlobalRef.current.disconnect(); // Disconnect the existing connection
        wsServiceGlobalRef.current.connect(); // Reconnect WebSocket
      }
      else{
        console.log(`[${getTimestamp()}] Global WebSocket connecting...`);
        wsServiceGlobalRef.current.connect(); // connect WebSocket
      }
    }
  };

  // Function to manually refresh trades and portfolio data
  const refreshTradesAndPortfolio = (refreshType) => {
    try{
      setRefreshing(true);
      if(refreshType=="trades"){
        fetchTrades(user_id);
      }
      else if(refreshType=="portfolio"){
        fetchPortfolio(user_id);
      }
      else if(refreshType=="both"){
        fetchTrades(user_id);
        fetchPortfolio(user_id);
        fetchPerformance(user_id);
        fetchUserDetails();
      }
      //setRefreshing(false);
    }catch(error){
      setRefreshing(false);
    }
  };

  const refreshPerformance = () => {
    setRefreshing(true);
    fetchPerformance(user_id);
  };

  // Helper function to get formatted timestamp
  const getTimestamp = () => {
    return new Date().toLocaleString('en-IN', { 
      year: 'numeric', 
      month: '2-digit', 
      day: '2-digit', 
      hour: '2-digit', 
      minute: '2-digit', 
      second: '2-digit',
      hour12: false 
    });
  };

  // Auto-refresh interval ref for pending orders
  const pendingRefreshIntervalRef = useRef(null);

  // Auto-refresh trades/portfolio/performance when there are pending orders
  useEffect(() => {
    // Clear existing interval if any
    if (pendingRefreshIntervalRef.current) {
      clearInterval(pendingRefreshIntervalRef.current);
      pendingRefreshIntervalRef.current = null;
    }

    // Check if there are any pending positions (orderStatus === 1)
    const hasPendingTrades = trades.some(trade => trade.orderStatus == 1 || trade.orderStatus === 1);
    const hasPendingPositions = positions.some(position => position.orderStatus == 1 || position.orderStatus === 1);
    const hasPendingOrders = hasPendingTrades || hasPendingPositions;

    // Check if there are pending orders
    if (hasPendingOrders && user_id) {
      console.log(`[${getTimestamp()}] Pending orders detected - starting auto-refresh every 5 seconds`);
      
      // Set up interval to refresh every 5 seconds
      pendingRefreshIntervalRef.current = setInterval(() => {
        console.log(`[${getTimestamp()}] Auto-refreshing trades/portfolio/performance due to pending orders...`);
        refreshTradesAndPortfolio('both');
      }, 5000); // 5 seconds interval
    } else {
      if (trades.length > 0 || positions.length > 0) {
        console.log(`[${getTimestamp()}] No pending orders - auto-refresh stopped`);
      }
    }

    // Cleanup interval on unmount or when dependencies change
    return () => {
      if (pendingRefreshIntervalRef.current) {
        clearInterval(pendingRefreshIntervalRef.current);
        pendingRefreshIntervalRef.current = null;
      }
    };
  }, [trades, positions, user_id]); // Re-run when trades or positions change

  // Handle app coming to foreground from background
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        // App came to foreground
        console.log(`[${getTimestamp()}] App came to foreground - checking WebSocket connections...`);
        
        // Check and reconnect regular WebSocket connection
        if (wsServiceRef.current) {
          const socket = wsServiceRef.current.socket;
          if (!socket || socket.readyState !== WebSocket.OPEN) {
            console.log(`[${getTimestamp()}] Regular WebSocket is not connected, reconnecting...`);
            reconnectWebSocket();
          } else {
            console.log(`[${getTimestamp()}] Regular WebSocket is connected`);
          }
        }
        
        // Check and reconnect global WebSocket connection
        // if (wsServiceGlobalRef.current) {
        //   const socket = wsServiceGlobalRef.current.socket;
        //   if (!socket || socket.readyState !== WebSocket.OPEN) {
        //     console.log(`[${getTimestamp()}] Global WebSocket is not connected, reconnecting...`);
        //     reconnectGlobalWebSocket();
        //   } else {
        //     console.log(`[${getTimestamp()}] Global WebSocket is connected`);
        //   }
        // }
        
        // Refresh all data when app comes to foreground
        if (user_id) {
          console.log(`[${getTimestamp()}] Refreshing data after coming to foreground...`);
          refreshTradesAndPortfolio('both');
        }
      }
    };

    const handleFocus = () => {
      // Additional check on window focus (for better compatibility)
      if (document.visibilityState === 'visible') {
        handleVisibilityChange();
      }
    };

    // Add event listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleFocus);

    // Cleanup event listeners on unmount
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleFocus);
    };
  }, [user_id]); // Re-run if user_id changes

  return (
    <WebSocketContext.Provider value={{ 
      mergerIDsEx, 
      isRefreshing, 
      stocks, 
      userScripts, 
      lastUpdateTime, 
      trades, 
      positions, 
      performance, 
      userDetails, 
      fetchUserScriptsExternal, 
      refreshPerformance, 
      fetchUserScripts, 
      refreshTradesAndPortfolio, 
      submitRejectionLog,
      // ============================================
      // NOTIFICATION VALUES - Easy to disable
      // ============================================
      // DISABLED FOR DEPLOYMENT - Uncomment when ready to test
      // To disable: Comment out the lines below
      // notifications,
      // isNotificationConnected
      notifications: [],
      isNotificationConnected: false
    }}>
      {children}
    </WebSocketContext.Provider>
  );
};

export { WebSocketProvider, WebSocketContext };
